import { AxiosRequestConfig } from 'axios';

import { BaseApi } from '@trukt/utils/BaseApi';

import {
  ClientServices,
  VendorServices,
  OrderService,
  CompanyService,
  AttachmentServices,
  FileServices,
  UserService,
  InspectionService,
  NoteService,
  ReportServices,
  LoadboardService,
  TerminalService,
  CommodityService,
  UserRoleService,
  GroupService,
  AccountService,
  ActivityService,
} from './services';
import { JobService } from './services/JobService';
import { PicklistService } from './services/PicklistService';
import { VehicleService } from './services/VehicleService';
import { EquipmentService } from './services/EquipmentService';
import { InvoiceService } from './services/InvoiceService';
import { CaseService } from './services/CaseService';
import { LineService } from './services/LineService';
import { CoupaService } from './services/CoupaService';
import { StopService } from './services/stop-service';
import { ContactServices } from './services/contact-services';
import { IntegrationService } from './services/integration-service';
import { CargoTelService } from './services/cargotel-service';

class TruktTmsApi extends BaseApi {
  account: AccountService;
  activity: ActivityService;
  cargotel: CargoTelService;
  case: CaseService;
  client: ClientServices;
  contact: ContactServices;
  vendor: VendorServices;
  commodity: CommodityService;
  equipment: EquipmentService;
  integration: IntegrationService;
  company: CompanyService;
  order: OrderService;
  attachments: AttachmentServices;
  file: FileServices;
  user: UserService;
  report: ReportServices;
  inspection: InspectionService;
  invoice: InvoiceService;
  line: LineService;
  note: NoteService;
  job: JobService;
  loadboard: LoadboardService;
  terminal: TerminalService;
  userRole: UserRoleService;
  group: GroupService;
  picklist: PicklistService;
  vehicle: VehicleService;
  coupa: CoupaService;
  stop: StopService;

  constructor(config: AxiosRequestConfig) {
    super(config);

    this.account = new AccountService(this.instance);
    this.activity = new ActivityService(this.instance);
    this.cargotel = new CargoTelService(this.instance);
    this.case = new CaseService(this.instance);
    this.client = new ClientServices(this.instance);
    this.contact = new ContactServices(this.instance);
    this.vendor = new VendorServices(this.instance);
    this.commodity = new CommodityService(this.instance);
    this.company = new CompanyService(this.instance);
    this.order = new OrderService(this.instance);
    this.attachments = new AttachmentServices(this.instance);
    this.file = new FileServices(this.instance);
    this.user = new UserService(this.instance);
    this.loadboard = new LoadboardService(this.instance);
    this.inspection = new InspectionService(this.instance);
    this.invoice = new InvoiceService(this.instance);
    this.line = new LineService(this.instance);
    this.note = new NoteService(this.instance);
    this.job = new JobService(this.instance);
    this.report = new ReportServices(this.instance);
    this.terminal = new TerminalService(this.instance);
    this.userRole = new UserRoleService(this.instance);
    this.group = new GroupService(this.instance);
    this.picklist = new PicklistService(this.instance);
    this.vehicle = new VehicleService(this.instance);
    this.equipment = new EquipmentService(this.instance);
    this.coupa = new CoupaService(this.instance);
    this.stop = new StopService(this.instance);
    this.integration = new IntegrationService(this.instance);
  }
}

export { TruktTmsApi };
